<div class="one" [ngClass]="class == true ? 'height-526 one' : 'height-525 one'" fxLayout="column">
  <div class="flex h-full">
    <div class="leftbox">
      <div class="avatar-section">
        <button mat-icon-button class="profile-img-btn">
          <img
            class="profile-avatar-img"
            [src]="
              finalfileToUpload && finalfileToUpload[0] !== '' ? finalfileToUpload[0] : IMAGEPATH
            "
          />
        </button>
        <div class="profile-name-container">
          <span class="profile-name">{{ userData?.FULLNAME }}</span>
        </div>
      </div>

      <div class="info-section">
        <div class="info-row">
          <span class="info-label">Phone:</span>
          <span class="info-value">{{ userData?.PHONE1 }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Email:</span>
          <span class="info-value">{{ userData?.EMAIL }}</span>
        </div>
      </div>

      <div class="actions-section">
        <button class="signature-btn" matButton="filled" color="accent" (click)="signaturDialog()">
          Edit Signatures
        </button>
      </div>
    </div>
    @if (
      ('Timeline' | tierPermission: 'Timeline') &&
      ('Timeline' | tierPermission: 'Timeline').ALLOWED == 1
    ) {
      <div class="rightbox">
        <app-timeline [currentUser]="currentUser"></app-timeline>
      </div>
    }
  </div>
</div>

<!-- <mat-dialog-actions align="end" class="popup_ftr">
<button id="callApiId" class="mainbtn_size" mat-raised-button color="accent">
  Save
</button>
</mat-dialog-actions> -->
